<!-- 大宗商质量数据/退次信息填写 -->
<template>
  <div>
    <h-inspection-page title="大宗商化工非直发领料" @inspection-update="inspectionUpdate">
      <form-header title="大宗商化工非直发领料">
        <template #body>
          <tr>
            <report-td title="供应商代码" colspan="4:8">{{ $route.query.supplyCode }}</report-td>
            <report-td title="供应商名称" colspan="4:8">{{ $route.query.supplyName }}</report-td>
          </tr>
          <tr>
            <report-td title="单号" colspan="4:8">
              <el-tooltip effect="red" placement="top-start" :disabled="false" :visible="contractNumberTips" content="单号不能为空！">
                <div></div>
              </el-tooltip>
              <el-autocomplete popper-class="planHidden" v-model="currentObj.contractNumber" :fetch-suggestions="getBadId"
                :trigger-on-focus="false" placeholder="请输入至少两位单号搜索" 
                    @clear="handleClear" clearable @blur="detailBlur('showMtlPlan')"
                    @focus="detailFocus('showMtlPlan')" @input="handleInput">
              </el-autocomplete>
              <h-detail width="460px" top="240px">
                <el-table v-show="plan.showMtlPlan" v-loading="reqLoading" :data="badIdList" border size="small"
                  max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true" height="540">
                  <el-table-column prop="contractNumber" label="单号" width="150"></el-table-column>
                  <el-table-column prop="mtlName" label="物料名称"></el-table-column>
                  <el-table-column prop="mtlCategoryName" label="物料类别" width="80"></el-table-column>
                </el-table>
              </h-detail>
            </report-td>
            <report-td title="物料号 " colspan="4:8">{{ currentObj.mtlNo }}</report-td>
          </tr>
          <tr>
            <report-td title="物料名称" colspan="4:8">{{ currentObj.mtlName }}</report-td>
            <report-td title="物料类别" colspan="4:8">{{ currentObj.mtlCategoryName }}</report-td>
          </tr>
          <tr>
            <report-td title="数量" colspan="4:8">{{ currentObj.amount }}</report-td>
            <report-td title="单位" colspan="4:8">{{ currentObj.unit }}</report-td>
          </tr>
          <tr>
            <report-td title="提单号" colspan="4:8">
              <el-tooltip effect="red" placement="top-start" :disabled="false" :visible="billNoTips" content="提单号不能为空！">
                <el-input v-model="currentObj.billNo" @input="handleInput1" clearable/>
              </el-tooltip>
            </report-td>
            <report-td title="领料日期" colspan="4:8">
              <el-tooltip effect="red" placement="top-start" :disabled="false" :visible="useDateTips" content="领料日期不能为空！">
                <div>
                  <el-date-picker v-model="currentObj.useDate" type="date" placeholder="请选择领料日期" clearable/>
                </div>
              </el-tooltip> 
            </report-td>
          </tr>
          <tr>
            <report-td title="领用数量" colspan="4:8">
              <el-tooltip effect="red" placement="top-start" :disabled="false" :visible="useAmountTips" content="领用数量不能为空！">
                <el-input v-model="currentObj.useAmount" maxlength="10" @input="handleInput2" clearable/>
              </el-tooltip>   
            </report-td>
            <report-td title="单位" colspan="4:8">{{ currentObj.unit1 }}</report-td>
          </tr>
        </template>
      </form-header>
    </h-inspection-page>
    <div style="padding-top:20px;padding-bottom:10px;">
      <h-button-group align="center">
        <h-button type="primary" @click="submitForm" :loading="btnLoading">提交</h-button>
        <h-button type="default" @click="handleCancel">返回</h-button>
      </h-button-group>
    </div>
  </div>
</template>

<script>
import { batchTestConclusionList } from '../hmqm/index'
import  moment  from 'moment'
export default {
  data(){
    return{
      currentObj:{
        contractNumber:''
      },
      batchTestConclusionList,
      fileTypeList:['png','PNG','jpg','JPG','jpeg','JPEG','pdf','PDF'],
      btnLoading: false,
      rejectsReplenishmentNumberTips: false,
      reasonTips: false,
      fileTips: false,
      plan : {
        showMtlPlan: false,
        planBlur: false,
        MtlOver600: false,
        SupplyOver600: false,
        showSupplyPlan: false,
      },
      total:0,
      reqLoading: false,
      badIdList:[],
      contractNumberTips: false,
      billNoTips: false,
      useDateTips: false,
      useAmountTips: false
    }
  },
  methods:{
    handleInput1(e){
      if(e){
        this.currentObj.billNo = e.replace(/[^1-9]/g, '')
      }else{
        this.currentObj.billNo = null
      }
      console.log('eeeeee',e,this.billNo)
    },
    handleInput2(e){
      if(e){
        this.currentObj.useAmount =  ('' + e) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      }else{
        this.currentObj.useAmount = null
      }
      console.log('eeeeee',e)
    },
    inspectionUpdate() {
      this.postThisPageHeight();
    },
    submitForm(){
      // if(billNo==null||billNo==''){
      //           alert("提单号不能为空！");
      //           return false;
      //       }
      //       if(contractNumber==null||contractNumber==''){
      //           alert("单号不能为空！");
      //           return false;
      //       }
      //       if(useDate==null||useDate==''){
      //           alert("领料日期不能为空！");
      //           return false;
      //       }
      //       if(useAmount==null||useAmount==''){
      //           alert("领用数量不能为空！");
      //           return false;
      //       }
      //       if(amount-useAmount<0){
      //           alert("领用数量不能大于总数量！");
      //           return false;
      //       }

      console.log('this.currentObj',this.currentObj)
      if(this.currentObj.contractNumber==null||this.currentObj.contractNumber==''||this.currentObj.contractNumber==undefined){
        this.contractNumberTips = true
        setTimeout(() => {
          this.contractNumberTips = false
        }, 2000);
        return
      }
      if(this.currentObj.billNo==null||this.currentObj.billNo==''||this.currentObj.billNo==undefined){
        this.billNoTips = true
        setTimeout(() => {
          this.billNoTips = false
        }, 2000);
        return
      }
      if(this.currentObj.useDate==null||this.currentObj.useDate==''||this.currentObj.useDate==undefined){
        this.useDateTips = true
        setTimeout(() => {
          this.useDateTips = false
        }, 2000);
        return
      }
      
      if(this.currentObj.useAmount==null||this.currentObj.useAmount==''||this.currentObj.useAmount==undefined){
        this.useAmountTips = true
        setTimeout(() => {
          this.useAmountTips = false
        }, 2000);
        return
      }
      if((this.currentObj.amount)-(this.currentObj.useAmount)<0){
          this.info("领用数量不能大于总数量！");
          return false;
      }
      let params = {
        contractNumber:this.currentObj.contractNumber,
        useDate: moment(this.currentObj.useDate).format('YYYY-MM-DD'),
        useAmount:this.currentObj.useAmount,
        billNo:this.currentObj.billNo,
        supplyCode:this.$route.query.supplyCode,
        supplyName:this.$route.query.supplyName
      }
      console.log('params',params)
      this.startLoading("保存中...")
      this.$http({
        url: `/base/doubleDistributionMaterial/submitFzfBulkSuppliers`,
        method: 'post',
        data:{
          ...params         
        }
      }).then((res) => {
        console.log('111res',res)
        if (res.data.code == 0) {
          this.success({
            title: "提示",
            message: res.data.data,
            confirmButtonText: "确定",
            callback: (action) => {
              this.handleCancel()
            },
          });
        } else {
          this.warning({
            message: res.data.msg ? res.data.msg : '失败',
            confirmButtonText: '确定',
            title: '失败'
          });
        }
        this.closeLoading()
      })
      .catch((err) => {
        this.closeLoading()
        this.warning({ message: err ? err : '失败', confirmButtonText: '确定', title: '失败' });
      });
    },
    handleCancel(){
      const params = {}
      params.supplyCode = this.$route.query.supplyCode
      params.supplyName = this.$route.query.supplyName
      params.roleCode = this.$route.query.roleCode

      params.parentId = this.$route.query.parentId

      
      this.$router.go(-1)
    },
    handleInput(val){
      let tmp = Object.assign({},{...this.currentObj})
      console.log('=========inputval',val,this.currentObj)
      if(val==''||val==null||val==undefined){
        this.currentObj = Object.assign({},{...tmp,mtlNo: '',
          mtlName: '',
          supplyCode: '',
          supplyName: '',
          sybName: '',
          badDescribe: '',
          badId:''})
        console.log('失焦为空数据',this.currentObj)
      }
    },
    // 弹窗聚焦
    detailFocus (v) {
      console.log('detailFocus v',v)
      this.plan.planBlur = false;
      if (v == "showSupplyPlan") {
        if (this.currentObj.badId&&this.currentObj.badId.length >=4) {
          this.plan[v] = true;
        }
      } else if (v == "showMtlPlan") {
        if (this.currentObj.badId&&this.currentObj.badId.length >= 4) {
          this.plan[v] = true;
        }
      }
    },
    detailBlur(v) {
      if (!this.plan.planBlur) {
        this.plan[v] = false;
      }
    },
    // 不良单号查询
    getBadId(query) {
      // if(this.currentObj.badType==''||this.currentObj.badType==null||this.currentObj.badType==undefined){
      //   this.info('请先选择不良类型')
      //   this.$refs.badIdRef.blur()
      //   return
      // }
      if(query.length>=2){
        this.reqLoading = true 
        this.$http({
          method: "post",
          url: "/base/inspectionReport/selectPage",
          headers: { "content-type": "application/json" },
          data: {
            pageNo: 1,
            pageSize: 10,
            // bulkSupplyCode:this.$route.query.supplyCode,
            dataFlag: 'HFZ',
            contractNumber: query,
          },
        }).then((res) => {
          console.log('ressss',res)
          if(res.data.code==0){
            this.plan.showMtlPlan = true
            this.badIdList = [...res.data.data.records]
            this.total = res.data.data.total
            console.log('res单号',this.badIdList)
          }else{
            this.badIdList = []
            this.plan.showMtlPlan = false
            this.error(res.data.msg||res.msg)
          }     
          this.reqLoading = false
        }).catch(err => {
          this.plan.showMtlPlan = false
          this.reqLoading = false
          console.log(err)
          this.error(err.data.msg||err.msg)
        }) 
      }else{
        this.badIdList = []
      }
    },
    clickMtlNo(row){
      console.log('rwo',row)
      this.plan.showMtlPlan = false;
      // let tmp = this.badIdList.find(item => item.rejectsId == row.rejectsId)
      // console.log('tmp',tmp)
      // if(tmp&&Object.keys(tmp).length>0){
      //   this.currentObj = Object.assign({},{...this.currentObj,...tmp,badId: tmp.rejectsId})
      // }
      this.currentObj = Object.assign({},{...row,
        contractNumber: row.contractNumber,
        mtlNo:row.mtlNo,
        mtlName:row.mtlName,
        mtlCategoryName:row.mtlCategoryName,
        amount:row.amount,
        unit:row.unit,
        billNo:row.billNo,
        useDate:row.useDate,
        useAmount:row.useAmount,
        unit1:row.unit
      })
    },
    handleClear(){
      this.plan.showMtlPlan = false
      this.currentObj = {
        contractNumber:'',
        mtlNo:'',
        mtlName:'',
        mtlCategoryName:'',
        amount:'',
        unit:'',
        billNo:'',
        useDate:'',
        useAmount:'',
        unit1:''
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.red{
  line-height: 30px;
  color: red;
}
.btn-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.report-name{
  margin-left: 10px;
  display: inline-block;
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
}
.el-input{
  width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
}
.blue-text{
  color: #165dff;
  cursor: pointer;
  margin-left: 10px;
}
</style>
<style lang="scss">
.el-popper.is-red {
  /* Set padding to ensure the height is 32px */
  padding: 6px 20px;
  background: linear-gradient(90deg, rgb(255, 0, 0), rgb(255, 0, 0));
  color: #fff;
}

.el-popper.is-red .el-popper__arrow::before {
  background: linear-gradient(45deg, #ff0000, #ff0000);
  right: 0;
}
.planHidden {
  display: none;
}
</style>